import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui 표준 클래스 병합 헬퍼 — 조건부 클래스(clsx) + tailwind 충돌 해소(twMerge). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
